import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { RadioButtonComponent } from '../../../../shared/components/radio-button/radio-button.component';
import { RadioButton } from '@shared/components/radio-button/radio-button';
import { GetRoamingPageDataUsecase } from '@usecase/roaming/get-roaming-page-data/get-roaming-page-data.usecase';
import { DataPage, RoamingPageData } from '@data/domain/roaming.entity';
import { take } from 'rxjs';
import { GetRoamingPageDataResp } from '@usecase/roaming/get-roaming-page-data/get-roaming-page-data.type';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePickerComponent } from '../../../../shared/components/date-picker/date-picker.component';
import { PickHourComponent } from '../../../../shared/components/pick-hour/pick-hour.component';
import { ITEM } from '@utils/constants';
import { GetRoamingHoursUsecase } from '@usecase/roaming/get-roaming-hours/get-roaming-hour.usecase';
import { GetRoamingHoursDto, GetRoamingHoursResp } from '@usecase/roaming/get-roaming-hours/get-roaming-hours.type';
import { PickHourModal } from '@shared/components/pick-hour/components/pick-hour-modal/pick-hour-modal';

@Component({
  selector: 'app-set-schedule',
  standalone: true,
  imports: [RadioButtonComponent, TranslatePipe, DatePickerComponent, PickHourComponent],
  templateUrl: './set-schedule.component.html',
  styleUrl: './set-schedule.component.scss'
})
export class SetScheduleComponent implements OnInit {
  roamingPageData!: RoamingPageData;
  private readonly dataPageOption = signal<{ name: Record<'id' | 'en', string>; activation_option: string }[]>([]);
  radioButtonOptions = computed<RadioButton[]>(() =>
    this.dataPageOption().map(item => ({
      label: item.name[this.currentLang()],
      value: item.activation_option
    }))
  );
  currentLang = signal<'id' | 'en'>('id');
  optionSelected = signal<string | undefined>(undefined);
  dateSelected = signal<string>('');
  timeSelected = signal<string>('');
  roamingHoursData = signal<PickHourModal>({
    hour: [],
    minutes: [],
    periods: []
  });

  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);
  readonly getRoamingPageDataUsecase = inject(GetRoamingPageDataUsecase);
  readonly getRoamingHoursUsecase = inject(GetRoamingHoursUsecase);
  readonly translateService = inject(TranslateService);

  isButtonValid = computed(()=> this.optionSelected() === 'resv' ? this.dateSelected() !== '' && this.timeSelected() !== '' : this.optionSelected());

  ngOnInit(): void {
    this.currentLang.set(this.translateService.currentLang as 'id' | 'en');
    this.translateService.onLangChange.subscribe(lang => {
      this.currentLang.set(lang.lang as 'id' | 'en');
    });
    this.getRoamingPageData();
  }

  getRoamingPageData() {
    this.getRoamingPageDataUsecase.execute().pipe(take(ITEM.SINGLE_EMISSION)).subscribe({
      next: (res: GetRoamingPageDataResp) => {
        this.roamingPageData = res.data;
        this.handleRadioButtonOption(res.data.dataPage);
      }
    });
  }

  handleRadioButtonOption(data: DataPage[]) {
    const ROAMING_TYPE = this.route.snapshot.params['type']; //store OR btl

    data.forEach(item => {
      if (item.type === ROAMING_TYPE) {
        this.dataPageOption.set(item.dataOption);

        if (item.dataOption.some(item => item.activation_option.includes('resv'))) this.getRoamingHours();
      }
    });
  }

  onClickContinue() {
    const { msisdn, packageId } = this.route.snapshot.queryParams;
    const { mlid } = this.route.snapshot.params;
    const QUERY_PARAMS = {
      type: 'roamingUmrahHaji',
      optionSelected: this.optionSelected(),
      date: this.dateSelected(),
      time: this.timeSelected(),
      msisdn,
      packageId
    };

    this.router.navigate([`roaming/checkout/${mlid}`], { queryParams: QUERY_PARAMS });
  }

  handleOptionSelected(event:string) {
    this.optionSelected.set(event);
    if(this.optionSelected() !== 'resv' ) {
      this.dateSelected.set('');
      this.timeSelected.set('');
    }
  }

  getRoamingHours() {
    const { msisdn } = this.route.snapshot.queryParams;
    const payload: GetRoamingHoursDto = {
      msisdn
    };

    this.getRoamingHoursUsecase.execute(payload).pipe(take(ITEM.SINGLE_EMISSION)).subscribe({
      next: (res: GetRoamingHoursResp) => {
        const {hour, minutes, periods} = res.time;
        this.roamingHoursData.set({
          hour,
          minutes,
          periods
        });
      }
    });
  }

}
